export default "__VITE_ASSET__BJzELw6T__"